if (!customElements.get('subscribe-form')) {
  class SubscribeForm extends HTMLElement {
    constructor() {
      super();
    }

    #form;

    connectedCallback() {
      this.#form = this.querySelector('form');
      this.#form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const formData = new FormData(this.#form);
        const email = formData.get('email');
        const url = this.#form.getAttribute('data-ajax-submit');
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'revision': '2022-02-16',
            'content-type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                list_id: this.getAttribute('data-list-id'),
                custom_source: 'Footer signup form',
                email: email,
              },
            },
          }),
        });

        if (!response.ok) {
          const data = await response.json();
          return this.handleErrors([{ detail: "Please enter an email address." }].map((error) => error.detail));
        }

        this.handleSuccess();
      });
    }

    handleErrors = (errors) => {
      this.querySelector('[data-success]').classList.add('hidden');
      this.querySelector('[data-errors]').innerHTML = errors.join(' ');
      this.querySelector('[data-errors]').classList.remove('hidden');
    };

    handleSuccess = () => {
      this.querySelector('[data-errors]').classList.add('hidden');
      this.querySelector('[data-success]').classList.remove('hidden');
    };
  }
  customElements.define('subscribe-form', SubscribeForm);
}
